import { Injectable } from "@angular/core";
import { UrlBuilder } from "../classes/url-builder";
import { QueryStringParameters } from "../classes/query-string-parameters";
import { Constants } from "src/app/config/constants";
import { environment } from "src/environments/environment";

@Injectable()
export class ApiEndpointsService {
  private baseUrl: string;
  private realApiBaseUrl: string;

  constructor(private constants: Constants) {
    this.baseUrl = environment.baseUrl;
    this.realApiBaseUrl = environment.baseUrl;
  }

  createUrl(action: string, isMockAPI: boolean = false): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(
      isMockAPI ? this.baseUrl : this.realApiBaseUrl,
      action
    );
    return urlBuilder.toString();
  }

  private createUrlWithQueryParameters(
    action: string,
    queryStringHandler?: (queryStringParameters: QueryStringParameters) => void
  ): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(this.baseUrl, action);
    if (queryStringHandler) {
      queryStringHandler(urlBuilder.queryString);
    }
    return urlBuilder.toString();
  }

  private createUrlWithPathVariables(
    action: string,
    pathVariables: any[] = []
  ): string {
    let encodedPathVariablesUrl: string = "";

    for (const pathVariable of pathVariables) {
      if (pathVariable !== null) {
        encodedPathVariablesUrl += `/${encodeURIComponent(
          pathVariable.toString()
        )}`;
      }
    }

    const urlBuilder: UrlBuilder = new UrlBuilder(
      this.baseUrl,
      `${action}${encodedPathVariablesUrl}`
    );

    return urlBuilder.toString();
  }

  public getMenuItems(companyId: string): string {
    return this.createUrl(`companies/${companyId}/menu-items`, true);
  }

  public getBaseData(): string {
    return this.createUrl(`base-data`, true);
  }
  public getCheckListItems(companyId: string, checkListId: string): string {
    return this.createUrl(
      `companies/${companyId}/check-lists/${checkListId}/items`,
      true
    );
  }

  public getQuestionnaire(companyId: string, questionnaireId: string): string {
    return this.createUrl(
      `companies/${companyId}/questionnaires/${questionnaireId}`,
      true
    );
  }

  public getMetricListItems(companyId: string, metricListId: string): string {
    return this.createUrl(
      `companies/${companyId}/metric-lists/${metricListId}/items`,
      true
    );
  }

  public getMetricData(companyId: string, metricId: string): string {
    return this.createUrl(
      `companies/${companyId}/metric-data/${metricId}`,
      true
    );
  }
}
